import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  addUser: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1),
    '&__form': {
      marginTop: theme.spacing(3),
      width: '100%', // Fix IE 11 issue.
      '&__select--error': {
        color: theme.palette.error.main,
      },
    },
  },
  formControl: {
    display: 'flex',
    '&__sheet': {
      flexDirection: 'row',
      width: '100%',
    },
    '&__text': {
      fontSize: 8,
    },
  },
}));
